import { useEffect, useState } from "react";
import { FiBookOpen } from "react-icons/fi";

export default function CatalogueCover({ book, eager = false }) {
	const [failed, setFailed] = useState(false);
	useEffect(() => setFailed(false), [book.id, book.book_cover?.url]);
	return book.book_cover?.url && !failed ? (
		<img src={book.book_cover.url} alt="" loading={eager ? "eager" : "lazy"} width="180" height="240" onError={() => setFailed(true)} />
	) : (
		<div className="catalogue-book-fallback">
			<FiBookOpen aria-hidden="true" />
			<span>{book.title}</span>
			{book.author && <small>{book.author}</small>}
		</div>
	);
}
